module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"companyName":"Company name","companySite":"Company website","user":"User","firstName":"First name","lastName":"Last name","email":"E-mail","pass":"Password","agreeTo":"I agree to the","privacyPolicy":"privacy policy","register":"Register","company":"Company","companyCountry":"Country","noCountryFound":"Country not found","repeatPass":"Confirm password"}}')
  delete Component.options._Ctor
}
